import React from 'react';
import { motion } from 'framer-motion';
import dummyProd from '../../Assets/Images/dummyProd.jpg';
import useGetHomeProducts from '../../hooks/use-get-home-product';
import { BsBookmarkHeart, BsBookmarkHeartFill } from 'react-icons/bs';
import { LuIndianRupee } from 'react-icons/lu';
import StarRatingDisplay from '../../Components/StarRatingDisplay';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function TileCard({ homeCards }) {
    const lang = useSelector((state) => state.theme.language);

    const { data: products } = useGetHomeProducts();
    const history = useHistory();

    const viewProduct = (value) => {
        history.push(`/product/${value._id}/view`);
    };

    const getProductDisplayName = (productDetails) => {
        if (lang === 'en') {
            const { productName, brandName } = productDetails || {};
            return [productName, brandName].filter(Boolean).join(' / ');
        } else if (lang === 'ta') {
            const { tProductName, tBrandName } = productDetails || {};
            return [tProductName, tBrandName].filter(Boolean).join(' / ');
        } else {
            const { productName, brandName } = productDetails || {};
            return [productName, brandName].filter(Boolean).join(' / ');
        }
    };

    return (
        <motion.div className="relative px-2 justify-center bg-white drop-shadow-lg py-10 w-full flex">
            <motion.div className="grid grid-cols-1 sm:grid-cols-1 gap-5 md:gap-10 md:grid-cols-1 xl:grid-cols-4 lg:grid-cols-4">
                {products &&
                    products?.map((pro, i) => {
                        return (
                            <motion.div
                                key={i}
                                className="relative w-72 flex flex-col bg-white cursor-pointer drop-shadow-lg"
                            >
                                <motion.div
                                    className="px-2 py-2 h-60 flex flex-row justify-center"
                                    onClick={() => viewProduct(pro)}
                                >
                                    <img
                                        src={pro?.images[0]?.imageUrl}
                                        className="object-contain"
                                        alt="preview"
                                    />
                                </motion.div>
                                <motion.div
                                    className="px-2 my-1 flex-row justify-between flex items-center font-bold text-xl"
                                    onClick={() => viewProduct(pro)}
                                >
                                    <motion.div className="flex flex-row items-center">
                                        <LuIndianRupee />
                                        {pro.offerPercentage === 0
                                            ? pro.price
                                            : pro.price * (pro.offerPercentage / 100)}
                                    </motion.div>
                                    <StarRatingDisplay reviews={pro.reviews} homePage={true} />
                                </motion.div>
                                <motion.div
                                    className="px-2 my-1 flex flex-row text-black"
                                    onClick={() => viewProduct(pro)}
                                >
                                    {getProductDisplayName(pro)}
                                </motion.div>
                            </motion.div>
                        );
                    })}
            </motion.div>
        </motion.div>
    );
}
